export var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//# sourceMappingURL=throwServerError.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/link/utils/throwServerError.js
// module id = 354
// module chunks = 0